import React from "react";
import PopoverMenu from "../../../design-system-components/PopoverMenu/PopoverMenu";

import { VisuallyHidden } from "@evidenceb/athena-common/ui/VisuallyHidden";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import { defineMessages, useIntl } from "react-intl";
import AccessibleButton from "../../AccessibleButton/AccessibleButton";
import { useDashboardRouter } from "../../../pages/DashBoard/DashboardTeacher/routing";
import { Link } from "react-router-dom";
import {
    useActivatePrintingSelection,
    usePrintStudentCodes,
} from "../../UsersCodePrinting/userCodePrintingHooks";

import "./DownloadStudentsSettings.scss";

interface Props {
    collectionId: string;
}

const DownloadStudentsSettings = ({ collectionId }: Props) => {
    const intl = useIntl();

    const { usersCodeDocument: getUsersCodeDocumentUrl } = useDashboardRouter();

    const printStudentCodes = usePrintStudentCodes();
    const activatePrintingSelection = useActivatePrintingSelection();

    const popoverMenuHandler = async (key: React.Key) => {
        if (key === "downloadAll") {
            printStudentCodes();
        } else if (key === "downloadSome") {
            activatePrintingSelection();
        }
    };

    return (
        <PopoverMenu
            className="download-students-settings"
            trigger={
                <AccessibleButton className="download-students-settings__trigger">
                    <Icon path="print_outline" size="medium" />
                    <Icon path="chevron_down" size="medium" />
                    <VisuallyHidden>
                        {intl.formatMessage(messages.openSettings)}
                    </VisuallyHidden>
                </AccessibleButton>
            }
            popoverPlacement="bottom end"
            onAction={popoverMenuHandler}
        >
            <PopoverMenu.Item
                key="downloadAll"
                textValue={intl.formatMessage(messages.downloadAll)}
            >
                <Link
                    to={getUsersCodeDocumentUrl(collectionId)}
                    className="download-students-settings__print-all"
                >
                    <Icon
                        path="list"
                        color={"var(--text-main-default)"}
                        size="medium"
                    />
                    {intl.formatMessage(messages.downloadAll)}
                </Link>
            </PopoverMenu.Item>

            <PopoverMenu.Item
                key="downloadSome"
                textValue={intl.formatMessage(messages.downloadSome)}
            >
                <button className="download-students-settings__print-some">
                    <Icon
                        path="download_square"
                        color={"var(--text-main-default)"}
                        size="medium"
                    />
                    <span>
                        <span>{intl.formatMessage(messages.downloadSome)}</span>
                        <span>
                            {intl.formatMessage(
                                messages.downloadSomeDescription
                            )}
                        </span>
                    </span>
                </button>
            </PopoverMenu.Item>
        </PopoverMenu>
    );
};
export default DownloadStudentsSettings;

const messages = defineMessages({
    downloadAll: {
        id: "download-students-settings-all",
        defaultMessage: "Download the student list",
    },
    downloadSome: {
        id: "download-students-settings-individual",
        defaultMessage: "Download individual student",
    },
    downloadSomeDescription: {
        id: "download-students-settings-individualDescription",
        defaultMessage: "To help yout students to login",
    },
    openSettings: {
        id: "download-students-settings-button",
        defaultMessage: "Download students code",
    },
});
